import { NoiseGenerator } from './noise';
import { BlockId } from '@shared/block-ids';

interface OreConfig {
  id: BlockId;
  minY: number;
  maxY: number;
  threshold: number;
  scale: number;
  seedOffset: number;
}

const ORE_CONFIGS: OreConfig[] = [
  { id: BlockId.COAL_ORE, minY: 5, maxY: 128, threshold: 0.7, scale: 0.1, seedOffset: 100 },
  { id: BlockId.IRON_ORE, minY: 5, maxY: 64, threshold: 0.75, scale: 0.1, seedOffset: 200 },
  { id: BlockId.GOLD_ORE, minY: 5, maxY: 32, threshold: 0.82, scale: 0.1, seedOffset: 300 },
  { id: BlockId.DIAMOND_ORE, minY: 5, maxY: 16, threshold: 0.88, scale: 0.1, seedOffset: 400 },
];

export function getOre(
  noise: NoiseGenerator,
  wx: number, wy: number, wz: number,
): BlockId | null {
  for (const cfg of ORE_CONFIGS) {
    if (wy < cfg.minY || wy > cfg.maxY) continue;

    const n = noise.get3D(
      (wx + cfg.seedOffset) * cfg.scale,
      wy * cfg.scale,
      (wz + cfg.seedOffset) * cfg.scale,
    );

    if (n > cfg.threshold) {
      return cfg.id;
    }
  }
  return null;
}
